import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { getLossAndDamageClaimsStatusEffect } from '../Claims/LossAndDamage/LossAndDamageClaimsEffects';
import { setLossAndDamageClaimsStatusList } from '../common/CommonActions';

const useLossAndDamageClaimStatusList = () => {
  const [list, setList] = useState(undefined);
  const { lossAndDamageStatus } = useSelector((state) => state.common);
  const dispatch = useDispatch();

  // biome-ignore lint/correctness/useExhaustiveDependencies: fix this
  useEffect(() => {
    if (lossAndDamageStatus.success) {
      setList(lossAndDamageStatus.data);
    } else {
      getList();
    }
  }, [lossAndDamageStatus]);

  const getList = async () => {
    try {
      dispatch(setLossAndDamageClaimsStatusList({ data: [], success: true }));
      const { data } = await getLossAndDamageClaimsStatusEffect();
      setList(data);
      dispatch(setLossAndDamageClaimsStatusList({ data, success: true }));
    } catch {
      setList([]);
    }
  };

  return list;
};

export default useLossAndDamageClaimStatusList;
